var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowUpBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 26,
    viewBox: "0 0 125 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M121.654 25.7999C97.0779 25.7999 88.2077 4.09962e-06 63.909 0C39.6105 -4.09957e-06 33.7757 25.7999 3.55811 25.7999C-26.6596 25.7999 146.231 25.7999 121.654 25.7999Z",
    fill: "#172249"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpBg);
export default __webpack_public_path__ + "static/media/arrowUpBg.f09ad9492e57debf675c33cdf472fdae.svg";
export { ForwardRef as ReactComponent };